
const digest = 'cf218aa778cc97e53ef98b27b8653d2daa6571abd5755a63d7e3c960705d13b0';
const classes = {"wrapper":"_wrapper_16hbt_1","extraBadge":"_extraBadge_16hbt_12","title":"_title_16hbt_23","status":"_status_16hbt_29","hint":"_hint_16hbt_36","haveToFillNow":"_haveToFillNow_16hbt_42","extra":"_extra_16hbt_12","scheduled":"_scheduled_16hbt_65","prescheduled":"_prescheduled_16hbt_65","cantFillNow":"_cantFillNow_16hbt_87","canFillNow":"_canFillNow_16hbt_109","completed":"_completed_16hbt_131","disabled":"_disabled_16hbt_153"};
const css = `._wrapper_16hbt_1 {
  border-radius: 5px;
  padding: 18px 24px;
  font-family: Rubik, sans-serif;
  cursor: pointer;
  height: 100%;
}
._wrapper_16hbt_1:hover {
  transform: scale(1.025);
}

._extraBadge_16hbt_12 {
  width: 40px;
  height: 20px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
}

._title_16hbt_23 {
  font-size: 16px;
  font-weight: 500;
  color: #ffffff;
}

._status_16hbt_29 {
  font-size: 12px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 10px;
}

._hint_16hbt_36 {
  font-size: 14px;
  color: #ffffff;
  text-decoration: underline;
}

._haveToFillNow_16hbt_42 {
  box-shadow: 0 5px 10px 0 rgba(246, 96, 120, 0.5);
  background: rgb(170, 15, 40);
  background: linear-gradient(97deg, rgb(170, 15, 40) 0%, rgb(241, 40, 72) 100%);
}
._haveToFillNow_16hbt_42 ._status_16hbt_29 {
  color: #ffeb00;
}
._haveToFillNow_16hbt_42._extra_16hbt_12 {
  background: rgba(170, 15, 40, 0.3);
  background: linear-gradient(97deg, rgba(170, 15, 40, 0.3) 0%, rgba(241, 40, 72, 0.3) 100%);
}
._haveToFillNow_16hbt_42._extra_16hbt_12 ._title_16hbt_23 {
  color: rgb(170, 15, 40);
}
._haveToFillNow_16hbt_42._extra_16hbt_12 ._hint_16hbt_36, ._haveToFillNow_16hbt_42._extra_16hbt_12 ._status_16hbt_29 {
  color: #000000;
}
._haveToFillNow_16hbt_42 ._extraBadge_16hbt_12 {
  background: rgb(170, 15, 40);
  color: #ffffff;
}

._scheduled_16hbt_65, ._prescheduled_16hbt_65 {
  background: rgb(17, 72, 152);
  background: linear-gradient(97deg, rgb(17, 72, 152) 0%, rgb(2, 64, 108) 100%);
}
._scheduled_16hbt_65 ._status_16hbt_29, ._prescheduled_16hbt_65 ._status_16hbt_29 {
  color: #25ff24;
}
._scheduled_16hbt_65._extra_16hbt_12, ._prescheduled_16hbt_65._extra_16hbt_12 {
  background: rgba(17, 72, 152, 0.3);
  background: linear-gradient(97deg, rgba(17, 72, 152, 0.3) 0%, rgba(2, 64, 108, 0.3) 100%);
}
._scheduled_16hbt_65._extra_16hbt_12 ._title_16hbt_23, ._prescheduled_16hbt_65._extra_16hbt_12 ._title_16hbt_23 {
  color: rgb(17, 72, 152);
}
._scheduled_16hbt_65._extra_16hbt_12 ._hint_16hbt_36, ._scheduled_16hbt_65._extra_16hbt_12 ._status_16hbt_29, ._prescheduled_16hbt_65._extra_16hbt_12 ._hint_16hbt_36, ._prescheduled_16hbt_65._extra_16hbt_12 ._status_16hbt_29 {
  color: #000000;
}
._scheduled_16hbt_65 ._extraBadge_16hbt_12, ._prescheduled_16hbt_65 ._extraBadge_16hbt_12 {
  background: rgb(17, 72, 152);
  color: #ffffff;
}

._cantFillNow_16hbt_87 {
  background: rgb(98, 98, 98);
  background: linear-gradient(97deg, rgb(98, 98, 98) 0%, rgb(149, 149, 149) 100%);
}
._cantFillNow_16hbt_87 ._status_16hbt_29 {
  color: #ffeb00;
}
._cantFillNow_16hbt_87._extra_16hbt_12 {
  background: rgba(98, 98, 98, 0.3);
  background: linear-gradient(97deg, rgba(98, 98, 98, 0.3) 0%, rgba(149, 149, 149, 0.3) 100%);
}
._cantFillNow_16hbt_87._extra_16hbt_12 ._title_16hbt_23 {
  color: #000000;
}
._cantFillNow_16hbt_87._extra_16hbt_12 ._hint_16hbt_36, ._cantFillNow_16hbt_87._extra_16hbt_12 ._status_16hbt_29 {
  color: #000000;
}
._cantFillNow_16hbt_87 ._extraBadge_16hbt_12 {
  background: rgb(98, 98, 98);
  color: #000000;
}

._canFillNow_16hbt_109 {
  background: rgb(225, 94, 0);
  background: linear-gradient(97deg, rgb(225, 94, 0) 0%, rgb(255, 151, 50) 100%);
}
._canFillNow_16hbt_109 ._status_16hbt_29 {
  color: #000000;
}
._canFillNow_16hbt_109._extra_16hbt_12 {
  background: rgba(225, 94, 0, 0.3);
  background: linear-gradient(97deg, rgba(225, 94, 0, 0.3) 0%, rgba(255, 151, 50, 0.3) 100%);
}
._canFillNow_16hbt_109._extra_16hbt_12 ._title_16hbt_23 {
  color: rgb(225, 94, 0);
}
._canFillNow_16hbt_109._extra_16hbt_12 ._hint_16hbt_36 {
  color: #000000;
}
._canFillNow_16hbt_109 ._extraBadge_16hbt_12 {
  background: rgb(225, 94, 0);
  color: #ffffff;
}

._completed_16hbt_131 {
  background: rgb(65, 154, 13);
  background: linear-gradient(97deg, rgb(65, 154, 13) 0%, rgb(79, 204, 5) 100%);
}
._completed_16hbt_131 ._status_16hbt_29 {
  color: #ffffff;
}
._completed_16hbt_131._extra_16hbt_12 {
  background: rgba(65, 154, 13, 0.3);
  background: linear-gradient(97deg, rgba(65, 154, 13, 0.3) 0%, rgba(79, 204, 5, 0.3) 100%);
}
._completed_16hbt_131._extra_16hbt_12 ._title_16hbt_23 {
  color: rgb(65, 154, 13);
}
._completed_16hbt_131._extra_16hbt_12 ._hint_16hbt_36, ._completed_16hbt_131._extra_16hbt_12 ._status_16hbt_29 {
  color: #000000;
}
._completed_16hbt_131 ._extraBadge_16hbt_12 {
  background: rgb(65, 154, 13);
  color: #ffffff;
}

._disabled_16hbt_153 {
  cursor: not-allowed;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  